import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ignoreDateRulesChecking: {
    id: 'view.card.claims.ignoreDateRulesChecking',
    defaultMessage: '(Rule date ignored)',
  },
});

